// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"256":"63d20ce1","4015":"5bde4c5c","8601":"ebdffbc8","8726":"5bde4c5c"}[chunkId] + ".chunk.css";
};